import { useBudouX } from "@/hooks/useBudouX";

const features = [
  {
    id: "1",
    title: 'どんなサーバー<br class="sp">でも軽快動作',
    desc: "必要最低限の環境でも高速･軽快に動作するよう、設計･開発されており、高いコストパフォーマンスを発揮します",
  },
  {
    id: "2",
    title: '強力な<br class="sp">SEO性能',
    desc: "動的CMS ならではの機動力を活かし、ファイル･ディレクトリの命名など、様々な設定が自由自在に行えSEOを強力にサポート",
  },
  {
    id: "3",
    title: '拡張性・外部<br class="sp">システム親和性',
    desc: "基幹業務システムと外部システムの連携も、思いのままに拡張可能です。また業務特化型の拡張テンプレートも多数ございます",
  },
  {
    id: "4",
    title: '万全な<br class="sp">セキュリティ対策',
    desc: "ソフト･ハード両面からセキュリティ対策を実施。Web上に存在する様々な脅威からの備えも万全です",
    sub: "※ハード対策はSaas版のみ",
  },
];

export const SpeedCmsFeatures = () => {
  const { parse } = useBudouX();
  return (
    <>
      <h3 className="w-full  font-bold text-sec fluid-text-[11px,18px]">
        Features of SpeedCMS
      </h3>
      <div className="col-span-1 mx-auto max-w-4xl font-bold leading-comfort text-pri fluid-text-[14px,18px]">
        {parse(
          "SpeedCMSは、エンタープライズ向けCMS。ウェブサイトの運用現場で求められるコア要件を満たし、低コストでどんな環境でも軽快に動作し、お客様のビジネスに合わせ柔軟に拡張できることが強みです。中規模向けサイトを中心に、コーポレートから、情報配信、会員向けサービス、ECなど様々な導入・運用実績がございます。"
        )}
      </div>
      <div className="grid grid-cols-2 gap-5">
        {features.map((feature) => (
          <dl className="grid-cols-1" key={feature.id}>
            <dt className="relative flex aspect-4/1 items-center justify-center rounded-full border border-solid border-pri text-center text-pri fluid-text-[14px,22px] md:border-bdc-accent">
              <h3
                className="relative z-10 font-bold"
                dangerouslySetInnerHTML={{
                  __html: `${feature.title}`,
                }}
              />
              <div className="absolute top-0 left-0 z-0 -mt-2 flex h-full w-full items-center justify-center leading-none text-sec/25 sm:hidden md:text-9xl">
                {feature.id}
              </div>
            </dt>
            <dd className="space-y-1 pt-2 font-normal">
              <p className="leading-relaxed text-txt-base fluid-text-[14px,18px] md:leading-comfort">
                {feature.desc}
                {feature.sub && (
                  <span className="text-ter">&ensp;{feature.sub}</span>
                )}
              </p>
            </dd>
          </dl>
        ))}
      </div>
    </>
  );
};
